import React from 'react';
import LogoImage from './resources/actmt-heart-icon-transparent.svg';
import './logo.css';

const Logo = () => {
  return <img className="LogoLogin" src={LogoImage} alt="ACTMT"></img>;
};

export default Logo;
